import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-gamepad-line text-white text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-white whitespace-nowrap">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-base">游戏分类</h3>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-base">快速链接</h3>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/dianzi-youxi" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热门游戏</Link></li>
              <li><Link to="/category/xin-pin-tuijian" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">最新推荐</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-base">联系我们</h3>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {siteInfo.year} {siteInfo.name} 版权所有 | 沪ICP备2024000001号
          </p>
          <p className="text-xs text-background-500">
            理性游戏，拒绝沉迷 | 未满18周岁禁止参与
          </p>
        </div>
      </div>
    </footer>
  );
}